module.exports = "/images/vendor/flag-icon-css/flags/1x1/rw.svg?997fe41bfffc77e0073f10d589ae6d27";